<template>
  <div class="">

    <!--

    This feature was replaced in v3 by the Marketing Plan Template feature.

    <b-modal
      v-model="showCopyPreviousPlan"
      title="Copy a previous plan?"
      :hide-footer="true"
      :no-close-on-esc="true"
      :no-close-on-backdrop="true"
    >
      We're excited that you're building your next Business Plan.
      Before you get started, would you like to save time and copy
      one of your previous plans?

      <ul class="list-unstyled my-3">
        <li>
          <b-form-radio v-model="copyPreviousPlan" :value="false" name="copy-plan">
            No, I just want to start from scratch
          </b-form-radio>
        </li>
        <li>
          <b-form-radio v-model="copyPreviousPlan" :value="true" name="copy-plan">
            Yes
          </b-form-radio>
        </li>
      </ul>
      <div
        v-if="copyPreviousPlan"
        class="form-group"
      >
        <label>Which plan do you want to copy?</label>
        <select
          class="form-control"
          v-model="copyFromPlan"
        >
          <option :value="null">Choose one</option>
          <option
            v-for="year in previousPlans"
            v-bind:key="year"
            :value="year"
          >
            {{ year}}
          </option>
        </select>
      </div>
      <hr>
      <div
        class="d-flex"
      >
        <button
          class="btn btn-primary mr-auto"
          :disabled="!copyFromPlan"
          @click.prevent="copyIntoPlan()"
        >
          <i class="fa fa-thumbs-up mr-1"></i>
          Copy {{ copyFromPlan }} plan
        </button>
        <button
          class="btn btn-link"
          @click.prevent="doNotCopyIntoPlan()"
        >
          No, thank you
        </button>
      </div>
    </b-modal>
    -->

    <b-modal
      v-model="oops"
      title="Oops!"
      :hide-footer="true"
      :no-close-on-esc="true"
      :no-close-on-backdrop="true"
      :hide-header-close="true"
    >
      Something went wrong, and we failed to load your business plan.
      You can try again by clicking the button below. If you see this message
      again please contact support.
      <hr>
      <div class="d-flex">
        <button
          class="btn btn-primary"
          @click.prevent="reload">
          <i class="fa fa-sync mr-1"></i>
          Reload Business Plan
        </button>
        <button
          class="btn btn-link ml-1 text-body"
          @click.prevent="exit">
          <i class="fa fa-home mr-1"></i>
          Exit
        </button>
      </div>
    </b-modal>

    <b-modal
      v-model="showTaskRebuild"
      title="Rebuild Your Tasks"
      :hide-footer="true"
      :no-close-on-esc="true"
      :no-close-on-backdrop="true"
      :hide-header-close="true"
    >
      If you've made changes to your Marketing Plan since activating
      it, you can <b>Rebuild Your Tasks</b>. Rebuilding your tasks
      from your plan will <u>delete</u> all of your {{ plan.year }}
      business planning tasks and will create new ones from your
      {{ plan.year }} business planning strategies (on this screen). It will <u>not</u> delete any
      tasks you've created manually.
      <hr>
      <button
        class="btn btn-block btn-primary"
        :disabled="rebuildingTaskList"
        @click.prevent="confirmTaskRebuild"
      >
        <span v-if="!rebuildingTaskList">
          Rebuild My Tasks
        </span>
        <span v-if="rebuildingTaskList">
          <i class="fa fa-fw fa-circle-o-notch fa-spin mr-1"></i>
          Rebuilding...
        </span>
      </button>
      <button
        class="btn btn-block btn-link"
        @click.prevent="showTaskRebuild = false"
      >
        I don't want to rebuild my tasks
      </button>
    </b-modal>

    <b-modal
      v-model="showTaskRebuildDone"
      title="Done!"
      :hide-footer="true"
      :no-close-on-esc="true"
      :no-close-on-backdrop="true"
      :hide-header-close="true"
    >
      Your tasks have been rebuilt for {{ plan.year }}.
      <hr>
      <a
        :href="urls.businessPlan.showTasks('upcoming', plan.user.id)"
        class="btn btn-primary btn-block"
      >
        Let's see them
        <i class="fa fa-fw fa-arrow-right ml-1"></i>
      </a>
    </b-modal>

    <b-modal
      v-model="showTaskRebuildSkipped"
      :hide-header="true"
      :hide-footer="true"
      :no-close-on-esc="true"
      :no-close-on-backdrop="true"
      :hide-header-close="true"
    >
      Your task list has not been modified. If you want to
      rebuild your task list at any time, just edit your
      Business Plan and click <b>Update Plan</b>.
      <hr>
      <button
        class="btn btn-primary"
        @click.prevent="exit">
        OK
      </button>
    </b-modal>

    <b-modal
      v-model="showActivationSuccess"
      :hide-footer="true"
      :no-close-on-esc="true"
      :no-close-on-backdrop="true"
      :hide-header-close="true"
      :title="`Your ${plan.year} plan has been activated!`"
    >
      Congratulations! You've finished setting your goals
      for {{ plan.year }}. Now, let's make sure your marketing
      strategies are in place so that you can execute
      your plan!
      <hr>
      <a
        :href="urls.businessPlan.showTasks('upcoming', plan.user.id)"
        class="btn btn-primary btn-block"
      >
        Continue
        <i class="fa fa-fw fa-arrow-right ml-1"></i>
      </a>
    </b-modal>

    <b-modal
      v-model="showCompPlanSettings"
      title="Comp Plan Settings"
      hide-footer
      @hide="cancelSavingCompPlan"
    >
      <p>
        Any changes made below are <u>only</u> reflected in
        {{ plan.year }} business plan for {{ plan.user.name }}.
        The agent cannot see these values in their own plan,
        but they are used to calculate Income Goals from
        the Sales Volume.
      </p>
      <number-box
        v-model="compPlan.split.agent_generated"
        class="mb-3"
        label="Personal Split"
        icon="fa-percent"
        append-icon
      ></number-box>
      <number-box
        v-model="compPlan.cap.company"
        class="mb-3"
        label="Company Cap"
        icon="fa-dollar"
      ></number-box>
      <div
        class="custom-control custom-checkbox"
      >
        <input
          v-model="plan.config.is_team_member"
          id="is-team-member"
          type="checkbox"
          class="custom-control-input"
        >
        <label
          class="custom-control-label"
          for="is-team-member"
        >
          This agent is a member of team
        </label>
      </div>
      <number-box
        v-if="plan.config.is_team_member"
        v-model="compPlan.split.team"
        class="mb-3 mt-3"
        label="Team Member's Split"
        icon="fa-percent"
        append-icon
      ></number-box>
      <number-box
        v-if="plan.config.is_team_member"
        v-model="compPlan.cap.team"
        label="Team Member's Cap"
        icon="fa-dollar"
      ></number-box>
      <hr>
      <div class="d-flex">
        <button
          class="btn btn-primary mr-1"
          @click.prevent="saveCompPlan"
        >
          Save Comp Plan
        </button>
        <button
          class="btn btn-link"
          @click.prevent="cancelSavingCompPlan"
        >
          Cancel
        </button>
      </div>
    </b-modal>

    <!-- =================================================================================== -->
    <!-- Notes Modal -->
    <!-- =================================================================================== -->
    <notes-modal
      v-if="canManageAgents && loaded"
      v-model="showNotes"
      :title="`${plan.user.name}, ${plan.year}`"
      annotatable-type="App\BusinessPlan"
      :annotatable-id="plan.id"
    >
      <div class="media align-items-center">
        <div class="media-body">
          <div class="media align-items-center">
            <div class="media-left mr-3">
              <toggle-button v-model="optedOut" color="#e74c3c" />
            </div>
            <div class="media-body small">
              Is <b class="text-danger">{{ optedOut ? 'not' : '' }}</b> participating in {{ plan.year }} business planning.
            </div>
          </div>
        </div>
        <div class="media-right">
          <button
            class="btn btn-sm btn-white"
            @click="showCompPlanSettings = true"
          >
            <i class="fa fa-cog mr-1"></i>
            Comp Plan
          </button>
        </div>
      </div>
      <hr>
    </notes-modal>
    <!-- =================================================================================== -->
    <!-- /Notes Modal -->
    <!-- =================================================================================== -->

    <!-- =================================================================================== -->
    <!-- Editor Buttons -->
    <!-- =================================================================================== -->
    <nav
      v-if="!showTaskRebuild && !preview && !readonly"
      class="navbar fixed-bottom navbar-dark bg-flat-dark-clouds"
    >
      <div class="container-fluid">
        <form
          v-if="plan.active === false"
          class="w-100 d-flex align-items-center"
        >
          <!--
          <button
            v-if="previousPlans.length > 0"
            class="btn btn-sm btn-link text-white text-decoration-none"
            @click.prevent="showCopyPreviousPlan = true"
          >
            <i class="fa fa-copy"></i>
            <span class="ml-1 d-none d-lg-inline-block">
              Copy Previous Plan
            </span>
          </button>
          -->
          <button
            :class="[
              'btn btn-lg text-dark btn-flat-dark-clouds mr-2 text-decoration-none ml-auto',
              {
                'btn-link': !plan.is_template,
                'btn-primary': plan.is_template
              }
            ]"
            :disabled="saving"
            @click.prevent="save()"
          >
            <span
              v-if="!plan.is_template"
            >
              Save Draft
            </span>
            <span
              v-if="plan.is_template"
            >
              Save Template
            </span>
          </button>
          <button
            class="btn btn-lg btn-primary"
            :disabled="saving"
            @click.prevent="saveAndActivate"
            v-if="!plan.is_template && canActivatePlan"
          >
            <i class="fa fa-rocket mr-1"></i>
            {{ saving ? 'Activating...' : 'Activate' }}
          </button>
        </form>
        <form
          v-if="plan.active === true && !plan.is_template"
          class="form-inline ml-auto"
        >
          <button
            class="btn btn-lg btn-primary"
            :disabled="saving"
            @click.prevent="saveAndShowTaskRebuild"
          >
            {{ saving ? 'Saving...' : 'Update Plan' }}
          </button>
        </form>
      </div>
    </nav>
    <!-- =================================================================================== -->
    <!-- /Editor Buttons -->
    <!-- =================================================================================== -->


    <div class="container-fluid pb-5 px-0 px-lg-3">

      <!-- =================================================================================== -->
      <!-- Manager's Header -->
      <!-- =================================================================================== -->
      <div
        v-if="canManageAgents && loaded"
        class="mb-5"
      >
        <div class="d-flex justify-content-between align-items-center alert alert-dark">
          <div>
            {{ plan.user.name }}, {{ plan.year }}
          </div>
          <button
            class="btn btn-dark"
            @click.prevent="showNotes = true"
          >
            <i class="fa fa-cog mr-1"></i>
            Admin Settings
          </button>
        </div>
      </div>
      <!-- =================================================================================== -->
      <!-- / Managers Header -->
      <!-- =================================================================================== -->

      <div
        v-if="!plan.is_template && !preview"
        class="business-plan-editor p-4 mb-4"
      >
        <section class="main">
          <header>
            <h3 class="h">
              My {{ plan.year }} Plan
            </h3>
            <hr>
          </header>
          <section>
            <div
              v-if="!canManageAgents && loaded"
              class="text-center"
            >
              {{ plan.user.name }} is <b class="text-danger">{{ optedOut ? 'not' : '' }}</b> participating in {{ plan.year }} business planning.
            </div>
          </section>
        </section>
      </div>

      <!--
      <div
        v-if="!plan.is_template && !preview"
        class="business-plan-editor bg-white p-4 mb-4 soft-shadow"
      >
        <section class="main">
          <header>
            <h3 class="h">
              Review Past Year's Transactions
            </h3>
            <hr>
          </header>
          <section
            v-if="!approvedLtm"
          >
            <div class="row">
              <div class="col-12 my-4">
                <a
                  :href="urls.businessPlan.showPrepwork(userId, this.plan.year)"
                  class="d-block alert alert-info mb-0 text-body text-center text-decoration-none"
                >
                  Please review your transactions.
                  <b class="ml-2 text-nowrap">
                    Get started
                    <i class="fa fa-arrow-right ml-1"></i>
                  </b>
                </a>
              </div>
            </div>
          </section>
          <section
            v-if="approvedLtm"
            class="container-fluid">
            <div class="row justify-content-center mb-4">
              <p class="col-md-8 text-center">
                The charts below demonstrate the
                effectiveness of your lead sources over the last twelve months.
                Hover over each segment (tap on mobile) to see data.
              </p>
            </div>
            <div class="row">
              <div class="col-12">
                <div
                  v-if="error"
                  class="alert alert-danger mb-0 media align-items-center"
                >
                  <div class="media-body">
                    Oops! There was a problem loading your data.
                  </div>
                  <div class="media-right">
                    <button
                      class="btn btn-danger ml-3"
                      @click.prevent="showHelp()"
                    >
                      Get Help
                    </button>
                  </div>
                </div>
                <div
                  v-if="!error"
                >
                  <a
                    v-if="incomplete"
                    :href="urls.businessPlan.showPrepwork(userId, year)"
                    class="d-block mb-3 alert alert-info text-center text-decoration-none"
                  >
                    <b>Tip:</b> These graphs would more useful if you finished
                    reviewing your transactions.
                    <span class="text-info text-underline">
                      Click here
                    </span>
                  </a>
                  <ul class="nav nav-tabs mb-4 justify-content-center">
                    <li class="nav-item" v-if="stats.listings.counts.length">
                      <a
                        :class="{ 'nav-link': true, 'active': dataset === 'listings' }"
                        href="#"
                        @click.prevent="dataset = 'listings'"
                      >Buyer and Seller Sides</a>
                    </li>
                    <li class="nav-item" v-if="stats.rentals.counts.length">
                      <a
                        :class="{ 'nav-link': true, 'active': dataset === 'rentals' }"
                        href="#"
                        @click.prevent="dataset = 'rentals'"
                      >Rentals</a>
                    </li>
                  </ul>
                  <div class="text-right">
                    <b-button-group>
                      <b-button
                        variant="link"
                        @click.prevent="chartType = 'pie'"
                      >
                        <i :class="{ 'fa fa-pie-chart': true, 'text-muted': chartType !== 'pie' }"></i>
                      </b-button>
                      <b-button
                        variant="link"
                        @click.prevent="chartType = 'bar'"
                      >
                        <i :class="{ 'fa fa-bar-chart': true, 'text-muted': chartType !== 'bar' }"></i>
                      </b-button>
                    </b-button-group>
                  </div>
                  <div v-show="!dataset || dataset === 'listings'">
                    <div v-show="!chartType || chartType === 'bar'">
                      <lead-source-bar-chart :height="180" :chart-data="listings.barChartData" :options="listings.barChartOptions"></lead-source-bar-chart>
                    </div>
                    <div v-show="!chartType || chartType === 'pie'">
                      <div class="row">
                        <div class="col-md-6">
                          <h3 class="h5 text-center mb-4">
                            Transactions
                          </h3>
                          <lead-source-pie-chart :chart-data="listings.countsPieChartData" :options="listings.pieChartOptions"></lead-source-pie-chart>
                        </div>
                        <div class="col-md-6">
                          <h3 class="h5 text-center mb-4">
                            Gross Sales
                          </h3>
                          <lead-source-pie-chart :chart-data="listings.salesPieChartData" :options="listings.pieChartOptions"></lead-source-pie-chart>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-show="!dataset || dataset === 'rentals'">
                    <div v-show="!chartType || chartType === 'bar'">
                      <lead-source-bar-chart :height="180" :chart-data="rentals.barChartData" :options="rentals.barChartOptions"></lead-source-bar-chart>
                    </div>
                    <div v-show="!chartType || chartType === 'pie'">
                      <div class="row">
                        <div class="col-md-6">
                          <h3 class="h5 text-center mb-4">
                            Transactions
                          </h3>
                          <lead-source-pie-chart :chart-data="rentals.countsPieChartData" :options="rentals.pieChartOptions"></lead-source-pie-chart>
                        </div>
                        <div class="col-md-6">
                          <h3 class="h5 text-center mb-4">
                            Gross Sales
                          </h3>
                          <lead-source-pie-chart :chart-data="rentals.salesPieChartData" :options="rentals.pieChartOptions"></lead-source-pie-chart>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <div
            v-if="!readonly"
          >
            <hr>
            <div class="text-right">
              <a :href="urls.businessPlan.showPrepwork(userId, this.plan.year)" class="btn btn-white">
                <i class="fa fa-list mr-1"></i>
                Review Transactions
              </a>
            </div>
          </div>
        </section>
      </div>
      -->

      <div
        v-if="!plan.is_template && !preview"
        class="business-plan-editor bg-white p-4 mb-4 position-relative soft-shadow"
      >
        <section class="main">
          <a
            href="https://accessredwood.com/support/guides/2031"
            class="btn btn-danger btn-help position-absolute"
            style="top:25px; right:20px;"
            target="_blank"
          >
            <i class="fa fa-question-circle"></i>
            <span class="ml-1 d-none d-lg-inline-block">
              Get Help
            </span>
          </a>
          <header>
            <h3 class="h">
              My Vision
            </h3>
            <hr>
          </header>
          <section>


            <!-- 2019 and 2020 plans -->
            <!-- ================================================================== -->
            <div
              v-if="showBenefitsAndConsequencesEditors"
            >
              <header class="text-center mb-5">
                <h4 class="h text-uppercase font-weight-bold mb-3">
                  Reasons Drive Behavior
                </h4>
                <p class="h4">
                  What are your <b>top 20 reasons</b> for executing this plan?
                </p>
              </header>

              <div class="row">
                <div class="col-md-6 mb-3">
                  <h5 class="h5 mb-3 text-uppercase font-weight-bold text-center">
                    Benefits of Action
                  </h5>
                  <ul class="list-group mb-3">
                    <li class="list-group-item" v-for="(benefit, i) in plan.config.why.benefits">
                      <div class="media">
                        <div class="media-left align-self-center mr-2">
                          <span class="h1">
                            {{ i < 9 ? '0' : '' }}{{ i + 1 }}
                          </span>
                        </div>
                        <div class="media-body align-self-center">
                          <input type="text" class="form-control border-0" placeholder="Type benefit here..." v-model="plan.config.why.benefits[i].content">
                        </div>
                        <div class="media-right align-self-center">
                          <button
                            class="btn btn-link text-muted"
                            @click.prevent="removeBenefit(i)"
                            v-if="!readonly"
                          >
                            <i class="fa fa-trash"></i>
                          </button>
                        </div>
                      </div>
                    </li>
                  </ul>
                  <button
                    class="btn btn-block btn-white"
                    @click.prevent="addBenefit"
                    v-if="!readonly"
                  >
                    <i class="fa fa-plus mr-1"></i>
                    Add Another Benefit
                  </button>
                </div>
                <div class="col-md-6 mb-3">
                  <h5 class="h5 mb-3 text-uppercase font-weight-bold text-center">
                    Consequences of Inaction
                  </h5>
                  <ul class="list-group mb-3">
                    <li class="list-group-item" v-for="(consequence, i) in plan.config.why.consequences">
                      <div class="media">
                        <div class="media-left align-self-center mr-2">
                          <span class="h1">
                            {{ i < 9 ? '0' : '' }}{{ i + 1 }}
                          </span>
                        </div>
                        <div class="media-body align-self-center">
                          <input type="text" class="form-control border-0" placeholder="Type consequence here..." v-model="plan.config.why.consequences[i].content">
                        </div>
                        <div class="media-right align-self-center">
                          <button
                            class="btn btn-link text-muted"
                            @click.prevent="removeConsequence(i)"
                            v-if="!readonly"
                          >
                            <i class="fa fa-trash"></i>
                          </button>
                        </div>
                      </div>
                    </li>
                  </ul>
                  <button
                    class="btn btn-block btn-white"
                    @click.prevent="addConsequence"
                    v-if="!readonly"
                  >
                    <i class="fa fa-plus mr-1"></i>
                    Add Another Consequence
                  </button>
                </div>

              </div>


            </div>
            <!-- ================================================================== -->
            <!--/ 2019 and 2020 plans -->

            <!-- 2021 plans and above -->
            <!-- ================================================================== -->
            <div
              v-if="showMyWhyDescriptionAndVision"
            >
              <div class="row">
                <div class="col-md-6 mb-3">
                  <h5 class="h5 mb-3 text-uppercase font-weight-bold text-center">
                    My Why
                  </h5>
                  <p class="mx-3 font-weight-bold">
                    What are the driving forces behind the creation of this plan?
                  </p>
                  <div class="mx-3">
                    <inline-editor
                      name="why_description"
                      v-model="plan.config.why.description"
                      placeholder="Type your answer here"
                    ></inline-editor>
                  </div>
                </div>
                <div class="col-md-6 mb-3">
                  <h5 class="h5 mb-3 text-uppercase font-weight-bold text-center">
                    Three Year Northstar
                  </h5>
                  <p class="mx-3 font-weight-bold">
                    Describe your life and business in 2028.
                  </p>
                  <div class="mx-3">
                    <inline-editor
                      name="why_vision"
                      v-model="plan.config.why.vision"
                      placeholder="Type your answer here"
                    ></inline-editor>
                  </div>
                </div>
              </div>
            </div>
            <!-- ================================================================== -->
            <!-- / 2021 plans and above -->
          </section>
          <!--
          <wistia-link
            :width="150"
            :description="false"
            href="https://c21redwood.wistia.com/medias/eixct0w1l0"
            class="position-absolute"
            style="top: 15px; right: 30px;"
          />
          -->
        </section>
      </div>

      <div
        v-if="!plan.is_template && !preview"
        class="business-plan-editor bg-white p-4 mb-4 position-relative soft-shadow"
      >
        <section class="main">
          <div
            class="text-right mb-4"
          >
            <!--
            <a
              :href="urls.dashboard.show()"
              class="btn btn-white"
              target="_blank"
            >
              <i class="fa fa-dashboard mr-1"></i>
              My Dashboard
            </a>
            -->
            <button
              v-if="canManageAgents"
              class="btn btn-white ml-2"
              @click="showCompPlanSettings = true"
            >
              <i class="fa fa-cog mr-1"></i>
              Comp Plan Settings
            </button>
            <hr>
          </div>

          <header>
            <h3 class="h">
              My Goals
            </h3>
            <hr>
          </header>

          <section class="mb-3">
            <header class="position-relative mb-4">
              <a
                href="https://accessredwood.com/support/guides/2032"
                class="btn btn-danger btn-help position-absolute"
                style="top:-20px; right:0px;"
                target="_blank"
              >
                <i class="fa fa-question-circle"></i>
                <span class="ml-1 d-none d-lg-inline-block">
                  Get Help
                </span>
              </a>
              <h4 class="h font-weight-bold mb-1">
                Income Goals
              </h4>
              <p class="mb-3">
                How much money will I produce by carrying out this plan?
              </p>
              <!--
              <wistia-link
                :width="150"
                :description="false"
                href="https://c21redwood.wistia.com/medias/zxd78s9mga"
                class="position-absolute"
                style="top: -20px; right: 0px;"
              />
              -->
            </header>

            <div class="row justify-content-center">
              <div class="col-12">

                <!-- 2020 plans and below -->
                <!-- ================================================================== -->
                <number-box
                  v-if="!allowManualSalesVolume"
                  label="Agent Generated Business"
                  variant="section mb-4 wider"
                  icon="fa-dollar"
                  no-body
                >
                  <div slot="card-footer">
                    <div class="card-group">
                      <number-box
                        id="income-goal"
                        v-model="plan.config.income_goal"
                        label="Income Goal"
                        variant="component"
                        icon="fa-dollar"
                        help="Income BEFORE company split"
                        :readonly="readonly"
                      />
                      <!--<number-box label="Transactions" variant="component" icon="fa-hashtag" help="Calculated below!" readonly v-model="transactionsGoal" />-->
                      <number-box label="Gross Commission %" variant="component" help="What you charge your clients">
                        <div slot="card-body" class="py-2 px-0 card-body">
                          <select
                            class="custom-select"
                            v-model="plan.config.gross_commissions"
                            :disabled="readonly"
                          >
                            <option value="2.5">2.50%</option>
                            <option value="2.75">2.75%</option>
                            <option value="3.0">3.00%</option>
                          </select>
                        </div>
                      </number-box>
                      <number-box
                        v-model="salesVolume"
                        label="Sales Volume"
                        variant="component"
                        icon="fa-dollar"
                        readonly
                        :placeholder="placeholders.sales_volume"
                      ></number-box>
                    </div>
                  </div>
                </number-box>
                <!-- /2020 plans and below -->
                <!-- ================================================================== -->

                <!-- 2021 plans and above -->
                <!-- ================================================================== -->
                <number-box
                  v-if="allowManualSalesVolume"
                  label="Agent Generated Business"
                  variant="section mb-4 wider"
                  icon="fa-dollar"
                  no-body
                >
                  <div slot="card-footer">
                    <div class="card-group">
                      <number-box
                        v-model="salesVolume"
                        label="Sales Volume"
                        variant="component"
                        icon="fa-dollar"
                        :placeholder="placeholders.sales_volume"
                        :readonly="readonly"
                      ></number-box>
                      <!--<number-box label="Transactions" variant="component" icon="fa-hashtag" help="Calculated below!" readonly v-model="transactionsGoal" />-->
                      <number-box label="Gross Commission %" variant="component" help="What you charge your clients">
                        <div slot="card-body" class="py-2 px-0 card-body">
                          <select
                            class="custom-select"
                            v-model="plan.config.gross_commissions"
                            :disabled="readonly"
                          >
                            <option value="2.5">2.50%</option>
                            <option value="2.75">2.75%</option>
                            <option value="3.0">3.00%</option>
                          </select>
                        </div>
                      </number-box>
                      <number-box
                        id="personal-income-goal"
                        label="Income Goal"
                        variant="component"
                        icon="fa-dollar"
                        readonly
                        help="Income AFTER company split"
                        :value="personalIncomeGoal"
                      />
                    </div>
                  </div>
                </number-box>
                <!-- ================================================================== -->
                <!-- /2021 plans and above -->


                <number-box label="Company Generated" variant="section mb-4 border-width-2" icon="fa-dollar" no-body>
                  <div slot="card-footer">
                    <div class="card-group">
                      <div class="card border-0 d-none d-md-block">
                        <!-- -->
                      </div>
                      <div class="card border-0 d-none d-md-block">
                        <!-- -->
                      </div>
                      <number-box
                        label="Income Goal"
                        variant="component"
                        icon="fa-dollar"
                        help="Income AFTER company split"
                        v-model="plan.config.co_generated_business"
                        :readonly="readonly"
                      />
                    </div>
                  </div>
                </number-box>

                <number-box label="Outbound Referrals" variant="section mb-4 border-width-2" icon="fa-dollar" no-body>
                  <div slot="card-footer">
                    <div class="card-group">
                      <number-box
                        v-model="plan.config.outbounds.transactions"
                        label="Closed Units"
                        variant="component"
                        icon="fa-hashtag"
                        help="I will close ___ outbound referrals."
                        :readonly="readonly"
                      ></number-box>
                      <number-box
                        v-model="plan.config.outbounds.avg_sale_price"
                        label="Average Sale Price"
                        variant="component"
                        icon="fa-dollar"
                        help="The average sales price of my outbound referrals will be ___."
                        :readonly="readonly"
                      ></number-box>
                      <number-box
                        id="outbounds-income-goal"
                        label="Income Goal"
                        variant="component"
                        icon="fa-dollar"
                        readonly
                        :value="outboundIncomeGoal"
                        help="Income from outbounds, assuming a commission rate of 2.5%."
                      />
                    </div>
                  </div>
                </number-box>

                <number-box
                  label="All In"
                  variant="section mb-4 border-width-2"
                  icon="fa-dollar"
                  no-body
                >
                  <div slot="card-footer">
                    <div class="card-group">
                      <div class="card border-0 d-none d-md-block">
                        <!-- -->
                      </div>
                      <div class="card border-0 d-none d-md-block">
                        <!-- -->
                      </div>
                      <number-box
                        label="Total Income Goal"
                        variant="component"
                        readonly
                        icon="fa-dollar"
                        help="Income AFTER company split"
                        :value="totalIncomeGoal"
                      />
                    </div>
                  </div>
                </number-box>

              </div>
            </div>

          </section>

          <div class="my-5">
            <hr>
          </div>

          <!-- ========================================================================================== -->
          <!-- Transaction Goals -->
          <!-- ========================================================================================== -->

          <section class="mb-3">
            <header class="position-relative mb-3">
              
              <a
                href="https://accessredwood.com/support/guides/2032"
                class="btn btn-danger btn-help position-absolute"
                style="top:-20px; right:0px;"
                target="_blank"
              >
                <i class="fa fa-question-circle"></i>
                <span class="ml-1 d-none d-lg-inline-block">
                  Get Help
                </span>
              </a>

              <h4 class="h font-weight-bold mb-1">
                Transactions Goals
              </h4>
              <p class="mb-3">
                How many personally generated transactions must I close to reach my income goal?
              </p>
            </header>
            <div class="card-deck">
              <number-box label="Sellers" variant="section mb-4 border-width-2" no-body-padding>
                <div slot="card-body">
                  <div class="">
                    <number-box
                      label="% Your Production"
                      v-model="plan.config.sellers.portion"
                      variant="component"
                      icon="fa-percent"
                      type="percent"
                      :placeholder="placeholders.sellers_portion"
                      append-icon
                      :readonly="readonly"
                    ></number-box>
                    <number-box
                      label="Average Sale Price"
                      v-model="plan.config.sellers.avg_sale_price"
                      variant="component"
                      icon="fa-dollar"
                      :placeholder="placeholders.sellers_avg_sale_price"
                      :readonly="readonly"
                    ></number-box>
                    <number-box
                      label="Average Commission"
                      variant="component"
                    >
                      <div slot="card-body" class="py-2 px-0 card-body">
                        <select
                          class="custom-select"
                          :value="plan.config.gross_commissions"
                          disabled
                        >
                          <option value="2.5">2.50%</option>
                          <option value="2.75">2.75%</option>
                          <option value="3.0">3.00%</option>
                        </select>
                        <div class="small help-text mt-1">
                          Set above in <b>Income Goals</b>.
                        </div>
                      </div>
                    </number-box>
                    <number-box
                      label="<span class='text-primary'>Seller Transactions Needed</span>"
                      variant="component"
                      icon="fa-hashtag"
                      placeholder=""
                      :readonly="true"
                      v-model="totalSellerTransactions"
                    ></number-box>
                  </div>
                </div>
              </number-box>
              <number-box label="Buyers" variant="section mb-4 border-width-2" no-body-padding>
                <div slot="card-body">
                  <div class="">
                    <number-box
                      label="% Your Production"
                      v-model="plan.config.buyers.portion"
                      variant="component"
                      icon="fa-percent"
                      type="percent"
                      :placeholder="placeholders.buyers_portion"
                      :readonly="readonly"
                      append-icon
                    ></number-box>
                    <number-box
                      label="Average Sale Price"
                      v-model="plan.config.buyers.avg_sale_price"
                      variant="component"
                      icon="fa-dollar"
                      :placeholder="placeholders.buyers_avg_sale_price"
                      :readonly="readonly"
                    ></number-box>
                    <number-box
                      label="Average Commission"
                      variant="component"
                    >
                      <div slot="card-body" class="py-2 px-0 card-body">
                        <select
                          class="custom-select"
                          :value="plan.config.gross_commissions"
                          disabled
                        >
                          <option value="2.5">2.50%</option>
                          <option value="2.75">2.75%</option>
                          <option value="3.0">3.00%</option>
                        </select>
                        <div class="small help-text mt-1">
                          Set above in <b>Income Goals</b>.
                        </div>
                      </div>
                    </number-box>
                    <number-box
                      label="<span class='text-primary'>Buyer Transactions Needed</span>"
                      variant="component"
                      icon="fa-hashtag"
                      placeholder=""
                      :readonly="true"
                      v-model="totalBuyerTransactions"
                    ></number-box>
                  </div>
                </div>
              </number-box>
              <number-box label="Leases" variant="section mb-4 border-width-2" no-body-padding>
                <div slot="card-body">
                  <div class="">
                    <number-box
                      label="% Your Income"
                      v-model="plan.config.leases.portion"
                      variant="component"
                      icon="fa-percent"
                      type="percent"
                      :placeholder="placeholders.leases_portion"
                      :readonly="readonly"
                      append-icon
                    ></number-box>
                    <number-box
                      label="Average Rent"
                      v-model="plan.config.leases.avg_rent"
                      variant="component"
                      icon="fa-dollar"
                      :readonly="readonly"
                    ></number-box>
                    <number-box
                      label="Average Commission"
                      variant="component"
                    >
                      <div slot="card-body" class="py-2 px-0 card-body">
                        <b-form-select
                          v-model="plan.config.leases.avg_commission"
                          :options="leasesAvgCommissionOptions"
                          :disabled="readonly"
                        ></b-form-select>
                        <div class="small help-text mt-1">
                          &nbsp;
                        </div>
                      </div>
                    </number-box>
                    <number-box
                      label="<span class='text-primary'>Lease Transactions Needed</span>"
                      variant="component"
                      icon="fa-hashtag"
                      placeholder=""
                      :readonly="true"
                      v-model="totalLeaseTransactions"
                    ></number-box>
                  </div>
                </div>
              </number-box>
            </div>

            <div class="alert alert-danger text-center border-0" v-if="portionsDoNotAddUpTo100">
              Your <b>% Your Production</b> fields do not add up to 100%.
              <i class="fa fa-thumbs-down ml-2"></i>
            </div>
            <div class="alert alert-flat-dark-clouds text-center border-0" v-if="!portionsDoNotAddUpTo100">
              Your <b>% Your Production</b> fields add up to 100%.
              <i class="fa fa-thumbs-up ml-2"></i>
            </div>

            <!--
            <span v-html="transactionsGoal"></span>
            -->
          </section>

          <div class="my-5">
            <hr>
          </div>

          <!-- 2019 and 2020 plans -->
          <!-- ================================================================== -->
          <section
            v-if="showTopLevelConversationGoals"
          >
            <header class="position-relative">
              <a
                href="https://accessredwood.com/support/guides/1367"
                class="btn btn-danger btn-help position-absolute"
                style="top:-20px; right:0px;"
                target="_blank"
              >
                <i class="fa fa-question-circle"></i>
                <span class="ml-1 d-none d-lg-inline-block">
                  Get Help
                </span>
              </a>
              <h4 class="h font-weight-bold mb-1">
                Conversations Goal
              </h4>
              <p class="mb-3">
                How many conversations must I conduct to reach my transactions goal?
              </p>
              <!--
              <wistia-link
                :width="150"
                :description="false"
                href="https://c21redwood.wistia.com/medias/qe84pgr8tg"
                class="position-absolute"
                style="top: -20px; right: 0px;"
              />
              -->
            </header>
            <div class="card-deck">
              <number-box label="Conversation Conversion Rate" variant="section mb-4 border-width-2" no-body-padding>
                <div slot="card-body">
                  <p class="mb-0 p-3 text-center">
                    Bear in mind that results may vary subject to skills and performance.
                  </p>
                  <div class="card-group">
                    <number-box label="New Agents" variant="component">
                      <div slot="card-body">
                        Anticipate <b>1 transaction</b> for every <b>80 business-focused conversations</b> with new leads or database contacts.
                      </div>
                    </number-box>
                    <number-box label="Experienced Agents" variant="component">
                      <div slot="card-body">
                        Anticipate <b>1 transaction</b> for every <b>40 business-focused conversations</b> with new leads or database contacts.
                      </div>
                    </number-box>
                    <number-box label="My Rate" variant="component">
                      <div slot="card-body">
                        I anticipate <b>1 transaction</b> for every...
                        <large-input
                          label="My Conversation Conversion Rate"
                          icon="fa-hashtag"
                          help="Business-minded conversations"
                          placeholder=""
                          v-model="plan.config.convos.conversion_rate"
                          :readonly="readonly"
                        ></large-input>
                      </div>
                    </number-box>
                  </div>
                </div>
              </number-box>
            </div>
            <div class="card-deck">
              <number-box label="Conversation Quota" variant="section mb-4 border-width-2" no-body-padding>
                <div slot="card-body">
                  <div class="card-group">
                    <number-box label="Annual Quota" variant="component" icon="fa-hashtag" help="( Seller + Buyer Sides ) x My Conversion Rate" :readonly="true" v-model="quotaConvosAnnual" />
                    <number-box label="Weekly Quota" variant="component" icon="fa-hashtag" help="Annual Quota ÷ 42 weeks" :readonly="true" v-model="quotaConvosWeekly" />
                    <number-box label="Daily Number" variant="component" icon="fa-hashtag" help="Weekly Quota ÷ 5 days" :readonly="true" v-model="quotaConvosDaily" />
                  </div>
                </div>
              </number-box>
            </div>
            <div class="card-deck">
              <number-box label="Hour of Power" variant="section mb-4 border-width-2" no-body>
                <div slot="card-footer">
                  <div class="card-group">
                    <number-box label="With People I Know" variant="component" icon="fa-hashtag" help="Daily Number ÷ 2" :readonly="true" v-model="quotaConvosKnown" />
                    <number-box label="With People I Don't Know" variant="component" icon="fa-hashtag" help="Daily Number ÷ 2" :readonly="true" v-model="quotaConvosUnknown" />
                  </div>
                </div>
              </number-box>
            </div>
          </section>
          <!-- ================================================================== -->
          <!-- /2019 and 2020 plans -->

          <!-- 2021 plans and above -->
          <!-- ================================================================== -->
          <section
            v-if="showConversionGoals"
          >
            <header class="position-relative mb-3">
              <a
                href="https://accessredwood.com/support/guides/2032"
                class="btn btn-danger btn-help position-absolute"
                style="top:-20px; right:0px;"
                target="_blank"
              >
                <i class="fa fa-question-circle"></i>
                <span class="ml-1 d-none d-lg-inline-block">
                  Get Help
                </span>
              </a>
              <h4 class="h font-weight-bold mb-1">
                Conversion Goals
              </h4>
              <p class="mb-3">
                How many conversations and appointments must I conduct to reach my transactions goal?
              </p>
              <!--
              <wistia-link
                :width="150"
                :description="false"
                href="https://c21redwood.wistia.com/medias/qe84pgr8tg"
                class="position-absolute"
                style="top: -20px; right: 0px;"
              />
              -->
            </header>
            <div class="card-deck">
              <number-box label="Listing Appointment<br>Close Rate" variant="section mb-4 border-width-2" no-body-padding>
                <div slot="card-body">
                  <number-box
                    v-model="plan.config.sellers.conversion_rate"
                    hide-header
                    hide-footer
                    help="I close ___% of my listing appointments: 1 per prospect."
                    variant="component"
                    icon="fa-percent"
                    placeholder=""
                    append-icon
                    :readonly="readonly"
                  ></number-box>
                </div>
              </number-box>
              <number-box label="Buyer Appointment<br>Close Rate"  variant="section mb-4 border-width-2" no-body-padding>
                <div slot="card-body">
                  <number-box
                    v-model="plan.config.buyers.conversion_rate"
                    hide-header
                    hide-footer
                    help="I close ___% of my initial buyer appointments, including initial showings + consultations: 1 per prospect."
                    variant="component"
                    icon="fa-percent"
                    placeholder=""
                    append-icon
                    :readonly="readonly"
                  ></number-box>
                </div>
              </number-box>
              <number-box label="Conversation To<br>Sale Ratio" variant="section mb-4 border-width-2" no-body-padding>
                <div slot="card-body">
                  <number-box
                    v-model="plan.config.convos.conversion_rate"
                    hide-header
                    hide-footer
                    help="I will close 1 transaction for every _____ business-minded conversations."
                    variant="component"
                    icon="fa-hashtag"
                    placeholder=""
                    :readonly="readonly"
                  ></number-box>
                </div>
              </number-box>
            </div>

            <div class="d-flex align-items-center justify-content-center my-4 pb-1 font-weight-bold">
              <span>What are my</span>
              <select
                class="custom-select col-5 col-lg-2 mx-2 text-center"
                v-model="showGoals"
              >
                <option value="weekly">
                  Weekly
                </option>
                <option value="monthly">
                  Monthly
                </option>
                <option value="annual">
                  Annual
                </option>
              </select>
              <span>goals?</span>
            </div>

            <div class="card-deck">
              <number-box
                label="Listing Appointment<br>Goals"
                variant="section mb-4 border-width-2"
                no-body-padding
              >
                <div slot="card-body">
                  <number-box
                    v-if="showGoals === 'daily'"
                    v-model="quotaListingApptsDaily"
                    hide-header
                    variant="component"
                    icon="fa-hashtag"
                    placeholder=""
                    :readonly="true"
                    help="Daily Listing Appointments"
                    type="text"
                  ></number-box>
                  <number-box
                    v-if="showGoals === 'weekly'"
                    v-model="quotaListingApptsWeekly"
                    hide-header
                    variant="component"
                    icon="fa-hashtag"
                    placeholder=""
                    :readonly="true"
                    help="Weekly Listing Appointments"
                    type="text"
                  ></number-box>
                  <number-box
                    v-if="showGoals === 'monthly'"
                    v-model="quotaListingApptsMonthly"
                    hide-header
                    variant="component"
                    icon="fa-hashtag"
                    placeholder=""
                    :readonly="true"
                    help="Monthly Listing Appointments"
                  ></number-box>
                  <number-box
                    v-if="showGoals === 'annual'"
                    v-model="quotaListingApptsAnnual"
                    hide-header
                    hide-footer
                    variant="component"
                    icon="fa-hashtag"
                    placeholder=""
                    :readonly="true"
                    help="Annual Listing Appointments"
                  ></number-box>
                </div>
              </number-box>
              <number-box
                label="Buyer Appointment<br>Goals"
                variant="section mb-4 border-width-2"
                no-body-padding
              >
                <div slot="card-body">
                  <number-box
                    v-if="showGoals === 'daily'"
                    v-model="quotaBuyerApptsDaily"
                    hide-header
                    variant="component"
                    icon="fa-hashtag"
                    placeholder=""
                    :readonly="true"
                    help="Daily Buyer Appointments"
                    type="text"
                  ></number-box>
                  <number-box
                    v-if="showGoals === 'weekly'"
                    v-model="quotaBuyerApptsWeekly"
                    hide-header
                    variant="component"
                    icon="fa-hashtag"
                    placeholder=""
                    :readonly="true"
                    help="Weekly Buyer Appointments"
                    type="text"
                  ></number-box>
                  <number-box
                    v-if="showGoals === 'monthly'"
                    v-model="quotaBuyerApptsMonthly"
                    hide-header
                    variant="component"
                    icon="fa-hashtag"
                    placeholder=""
                    :readonly="true"
                    help="Monthly Buyer Appointments"
                  ></number-box>
                  <number-box
                    v-if="showGoals === 'annual'"
                    v-model="quotaBuyerApptsAnnual"
                    hide-header
                    hide-footer
                    variant="component"
                    icon="fa-hashtag"
                    placeholder=""
                    :readonly="true"
                    help="Annual Buyer Appointments"
                  ></number-box>
                </div>
              </number-box>
              <number-box
                label="Conversation<br>Goals"
                variant="section mb-4 border-width-2"
                no-body-padding
              >
                <div slot="card-body">
                  <number-box
                    v-if="showGoals === 'daily'"
                    v-model="quotaConvosDaily"
                    hide-header
                    variant="component"
                    icon="fa-hashtag"
                    placeholder=""
                    :readonly="true"
                    help="Conversation/Day"
                  ></number-box>
                  <number-box
                    v-if="showGoals === 'weekly'"
                    v-model="quotaConvosWeekly"
                    hide-header
                    variant="component"
                    icon="fa-hashtag"
                    placeholder=""
                    :readonly="true"
                    :help="`${quotaConvosWeekly} Conversations/Week is ${quotaConvosDaily} Conversations/Day`"
                  ></number-box>
                  <number-box
                    v-if="showGoals === 'monthly'"
                    v-model="quotaConvosMonthly"
                    hide-header
                    variant="component"
                    icon="fa-hashtag"
                    placeholder=""
                    :readonly="true"
                    :help="`${quotaConvosMonthly} Conversations/Month is ${quotaConvosDaily} Conversations/Day`"
                  ></number-box>
                  <number-box
                    v-if="showGoals === 'annual'"
                    v-model="quotaConvosAnnual"
                    hide-header
                    hide-footer
                    variant="component"
                    icon="fa-hashtag"
                    placeholder=""
                    :readonly="true"
                    :help="`${quotaConvosAnnual} Conversations/Year is ${quotaConvosDaily} Conversations/Day`"
                  ></number-box>
                </div>
              </number-box>
            </div>

            <div class="card-deck">
              <div class="card border-0 d-none d-md-block">
                <!-- -->
              </div>
              <div class="card border-0 d-none d-md-block">
                <!-- -->
              </div>
              <div class="card border-0 font-weight-bold text-center">
                Daily number = {{ quotaConvosDaily }} conversations.
              </div>
            </div>
          </section>
          <!-- ================================================================== -->
          <!-- /2021 plans and above -->

          <div class="my-5">
            <hr>
          </div>

          <section
            v-if="showProspectingGoals"
          >
            <header class="position-relative mb-3">
              <a
                href="https://accessredwood.com/support/guides/2032"
                class="btn btn-danger btn-help position-absolute"
                style="top:-20px; right:0px;"
                target="_blank"
              >
                <i class="fa fa-question-circle"></i>
                <span class="ml-1 d-none d-lg-inline-block">
                  Get Help
                </span>
              </a>
              <h4 class="h font-weight-bold mb-1">
                Prospecting Goals
              </h4>
              <p class="mb-3">
                When will you do your daily prospecting?
              </p>
              <!--
              <wistia-link
                :width="150"
                :description="false"
                href="https://c21redwood.wistia.com/medias/qe84pgr8tg"
                class="position-absolute"
                style="top: -20px; right: 0px;"
              />
              -->
            </header>
            <div class="d-flex justify-content-center">
              <div class="list-group" style="max-width:450px;">
                <div class="list-group-item">
                  <div class="custom-control custom-radio">
                    <b-form-radio
                      v-model="prospectingGoalType"
                      name="prospecting_goal"
                      value="prospecting_hour"
                    >
                      I will attend <a href="#">Redwood Prospecting Hour</a> each day between 10:00 AM and 11:00 AM
                    </b-form-radio>
                  </div>
                </div>
                <div class="list-group-item">
                  <div class="custom-control custom-radio">
                    <b-form-radio
                      v-model="prospectingGoalType"
                      name="prospecting_goal"
                      value="prospecting_custom"
                    >
                      I will prospect on my own every day<span v-if="'prospecting_custom' === prospectingGoalType">:</span>
                    </b-form-radio>
                  </div>
                  <div
                    v-if="'prospecting_custom' === prospectingGoalType"
                    class="d-flex justify-content-center"
                  >
                    <div class="text-center">
                      <label
                        for="prospecting_hour_custom_start"
                        class="font-weight-bold"
                      >
                        Start
                      </label>
                      <b-form-timepicker
                        id="prospecting_hour_custom_start"
                        v-model="customProspectingHourStart"
                        locale="en"
                      ></b-form-timepicker>
                    </div>
                    <div class="mx-1"></div>
                    <div class="text-center">
                      <label
                        for="prospecting_hour_custom_end"
                        class="font-weight-bold"
                      >
                        Stop
                      </label>
                      <b-form-timepicker
                        id="prospecting_hour_custom_end"
                        v-model="customProspectingHourEnd"
                        locale="en"
                      ></b-form-timepicker>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

        </section>

      </div>

      <div
        v-if="plan.is_template && !preview"
        class="business-plan-editor bg-white pt-4 px-4 pb-1 mb-4 position-relative soft-shadow"
      >
        <section class="main pb-3 position-relative">
          <header>
            <h3 class="h">
              Template Editor
            </h3>
            <hr>
          </header>
        </section>

        <section class="row justify-content-center">
          <div class="col-md-4">
            <div class="form-group">
              <label for="x_template_name">
                Template Name
              </label>
              <input
                id="x_template_name"
                v-model="plan.config.x_template_name"
                class="form-control"
                name="x_template_name"
              >
            </div>
          </div>
        </section>

      </div>

      <div
        id="my_marketing_plan"
        class="business-plan-editor bg-white pt-4 px-4 pb-1 mb-4 position-relative soft-shadow"
      >

        <section class="main pb-3 position-relative">
          <a
            href="https://accessredwood.com/support/guides/2033"
            class="btn btn-danger btn-help position-absolute"
            style="top: 0px; right: 0px;"
            target="_blank"
          >
            <i class="fa fa-question-circle"></i>
            <span class="ml-1 d-none d-lg-inline-block">
              Get Help
            </span>
          </a>
          <header>
            <h3
              v-if="!plan.is_template"
              class="h"
            >
              My Marketing Plan
            </h3>
            <h3
              v-if="plan.is_template"
              class="h"
            >
              {{ plan.x_template_name }} Marketing Plan Template
            </h3>
            <hr>
          </header>

          <section>
            <header class="mb-3">
              <h4 class="h font-weight-bold mb-2">
                My Lead Sources
              </h4>
              <p>
                On what lead sources will you be spending your time and
                money to develop?
              </p>
            </header>

            <ul class="list-group mb-3">
              <li class="list-group-item" v-for="(source, i) in plan.config.lead_sources">
                <div class="media">
                  <div class="media-left align-self-center mr-3">
                    <span class="h1">
                      {{ i < 9 ? '0' : '' }}{{ i + 1 }}
                    </span>
                  </div>
                  <div class="media-body align-self-center">
                    <div class="form-row">
                      <div class="col-md-6">
                        <select
                          class="custom-select"
                          v-model="plan.config.lead_sources[i].name"
                          :disabled="preview || readonly"
                        >
                          <option
                            :value="null"
                          >
                            Choose Lead Source...
                          </option>
                          <option
                            v-for="name in leadSourcesValues"
                            :value="name"
                          >{{ name }}</option>
                        </select>
                      </div>
                      <div class="col-md-6" v-if="plan.config.lead_sources[i].name === 'Custom' || plan.config.lead_sources[i].name === 'Other'">
                        <input
                          type="text"
                          class="form-control"
                          placeholder="What is your Lead Source called?"
                          v-model="plan.config.lead_sources[i].custom"
                          :readonly="preview || readonly"
                        >
                      </div>
                      <div class="col-md-6" v-if="plan.config.lead_sources[i].name === 'Geographic Farm' || plan.config.lead_sources[i].name === 'Geo-Farming'">
                        <input
                          type="text"
                          class="form-control"
                          placeholder="Where are you farming? (Optional)"
                          v-model="plan.config.lead_sources[i].custom"
                          :readonly="preview || readonly"
                        >
                      </div>
                      <div class="col-md-6" v-if="plan.config.lead_sources[i].name === 'Niche' || plan.config.lead_sources[i].name === 'Niche Marketing'">
                        <input
                          type="text"
                          class="form-control"
                          placeholder="What is the niche? (Optional)"
                          v-model="plan.config.lead_sources[i].custom"
                          :readonly="preview || readonly"
                        >
                      </div>
                    </div>
                  </div>
                  <div class="media-right align-self-center">
                    <button
                      v-if="!preview && !readonly"
                      class="btn btn-link text-muted"
                      @click.prevent="removeLeadSource(i)"
                    >
                      <i class="fa fa-trash"></i>
                    </button>
                  </div>
                </div>
              </li>
            </ul>
            <div
              v-if="!preview && !readonly"
              style="max-width:300px; margin:0 auto;"
            >
              <button class="btn btn-block btn-primary" @click.prevent="addLeadSource">
                <i class="fa fa-plus mr-1"></i>
                Add Lead Source
              </button>
            </div>
          </section>
          <!--
          <wistia-link
            :width="150"
            :description="false"
            href="https://c21redwood.wistia.com/medias/t8rzno7lpo"
            class="position-absolute"
            style="top: -10px; right: 0px;"
          />
          -->

          <div v-if="plan.config.lead_sources.length < 1">
            <div class="my-5">
              <hr>
            </div>
            <div class="alert alert-info text-center">
              Please add <b>Lead Sources</b> to continue.
            </div>
          </div>

          <div v-for="(source, i) in plan.config.lead_sources">
            <div
              v-if="i === 0"
              class="my-5"
            >
              <hr>
            </div>

            <section class="">
              <header v-if="i === 0">
                <h4 class="h font-weight-bold mb-2">
                  Marketing Activities
                </h4>
                <p>
                  Build your list of marketing activities: one list for each Lead Source you want to develop.
                </p>
              </header>

              <section>
                <div class="row mt-3">
                  <div class="col-12" v-for="(strategy, s) in plan.config.lead_sources[i].strategies">
                    <number-box :label="`${leadSourceName(source)} ${strategy.name}`" variant="section border-width-2 mb-0" no-body-padding>
                      <div slot="card-body">
                        <table class="table table-responsive-md mb-0">
                          <thead>
                            <tr>
                              <th class="font-weight-bold border-bottom-0" style="min-width:200px;">
                                <span class="d-md-none">
                                  Activity
                                </span>
                                <span class="d-none d-md-inline-block">
                                  Marketing Activity
                                </span>
                              </th>
                              <th class="font-weight-bold border-bottom-0" style="min-width:200px;">
                                <span class="d-md-none">
                                  Notes
                                </span>
                                <span class="d-none d-md-inline-block">
                                  Who, What, When, Where, How?
                                </span>
                              </th>
                              <th class="font-weight-bold border-bottom-0" style="min-width:100px;">
                                Timeframe
                              </th>
                              <th
                                v-if="!preview && !readonly"
                                class=" border-bottom-0"  style="min-width:50px;"
                              ></th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="(activity, a) in plan.config.lead_sources[i].strategies[s].activities">
                              <td class="p-1">
                                <strategy-input
                                  v-model="plan.config.lead_sources[i].strategies[s].activities[a].content"
                                  :type="strategy.name"
                                  :source="source.name"
                                  :readonly="preview || readonly"
                                  placeholder="Marketing Activity..."
                                  @selected="onStrategySelection(arguments[0], plan.config.lead_sources[i].strategies[s].activities[a])"
                                ></strategy-input>
                                <!--<input type="text" class="form-control input-sm border-0" placeholder="Describe strategy here..." v-model="plan.config.lead_sources[i].strategies[s].activities[a].content">-->
                              </td>
                              <td class="p-1">
                                <input
                                  type="text"
                                  class="form-control"
                                  v-model="plan.config.lead_sources[i].strategies[s].activities[a].description"
                                  placeholder="Notes..."
                                  :readonly="preview || readonly"
                                >
                              </td>
                              <td class="p-1">
                                <select
                                  class="custom-select border-0"
                                  v-model="plan.config.lead_sources[i].strategies[s].activities[a].frequency"
                                  :disabled="preview || readonly"
                                >
                                  <option v-for="freq in activityFrequencies" :value="freq">{{ freq }}</option>
                                </select>
                              </td>
                              <td
                                v-if="!preview && !readonly"
                                class="p-0 text-right"
                              >
                                <button class="btn btn-link text-muted mr-1" @click.prevent="removeActivity(plan.config.lead_sources[i].strategies[s].activities, a)">
                                  <i class="fa fa-trash"></i>
                                </button>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <div
                          v-if="!preview"
                          class="p-2"
                        >
                          <div style="max-width:300px; margin:15px auto;">
                            <button
                              class="btn btn-primary btn-block"
                              @click.prevent="addActivity(plan.config.lead_sources[i].strategies[s].activities)"
                              v-if="!readonly"
                            >
                              <i class="fa fa-plus mr-1"></i>
                              Add Another Task
                            </button>
                          </div>
                        </div>
                      </div>
                    </number-box>
                  </div>
                </div>
              </section>
            </section>

          </div>

          <div
            v-if="!plan.is_template && !preview && !readonly"
          >
            <hr>
            <div class="text-right">
              <button
                class="btn btn-white"
                @click.prevent="showTemplatePickerAgain = true"
              >
                <i class="fa fa-sync mr-1"></i>
                Use a Different Template
              </button>
            </div>
          </div>

        </section>

        <div
          v-if="preview"
          class="sample-marketing-plan"
        >
          <span>Sample</span>
        </div>

        <form
          v-if="(!hasMadeTemplateDecision || showTemplatePickerAgain) && !plan.is_template"
          id="business_plan_template_picker"
          class="marketing-plan-template-picker"
          method="post"
          :action="urls.businessPlan.setTemplate(userId, year)"
          @submit.prevent="setTemplate()"
        >
          <slot name="csrf_token"></slot>
          <div class="container mt-5 pt-5">
            <div class="row justify-content-center">
              <div class="col-md-8">
                <div class="card">
                  <div class="card-body">
                    <h1 class="h4 font-weight-normal mb-4">
                      Get a head start on your Marketing Plan&mdash;use a template!
                    </h1>
                    <p>
                      Choose one of the templates below to import <b>Lead Sources</b>
                      and <b>Marketing Activities</b> into your plan.
                      You can also choose to import your sources and activities
                      from last year, or start from scratch! Choose an option below
                      to continue.
                    </p>
                    <ul class="list-unstyled">
                      <li
                        v-for="template in templates"
                        :key="`template_${template.id}`"
                        class="custom-control custom-radio"
                      >
                        <input
                          :id="`template_${template.id}`"
                          v-model="marketingPlanTemplateChoice"
                          type="radio"
                          name="from_template"
                          :value="template.id"
                          class="custom-control-input"
                        >
                        <label
                          class="custom-control-label"
                          :for="`template_${template.id}`"
                        >
                          {{ template.template_name }}
                        </label>
                        <a
                          :href="urls.businessPlan.showTemplatePreview(template.user_id, template.year)"
                          class="ml-1"
                          target="_blank"
                        >
                          preview
                        </a>
                      </li>
                      <li
                        v-if="plan.config.previous_plan.id"
                        class="custom-control custom-radio"
                      >
                        <input
                          id="template_last_year"
                          v-model="marketingPlanTemplateChoice"
                          type="radio"
                          name="from_template"
                          :value="plan.config.previous_plan.id"
                          class="custom-control-input"
                        >
                        <label
                          class="custom-control-label"
                          for="template_last_year"
                        >
                          Use my plan from last year
                          <a
                            :href="urls.businessPlan.showEdit(plan.user_id, plan.config.previous_plan.year) + '?preview=1#my_marketing_plan'"
                            class="ml-1"
                            target="_blank"
                          >
                            preview
                          </a>
                        </label>
                      </li>
                    </ul>
                    <hr>
                    <button
                      class="btn btn-primary btn-block"
                      :disabled="!marketingPlanTemplateChoice"
                    >
                      Load Marketing Plan Template
                    </button>
                    <button
                      v-if="!hasMadeTemplateDecision"
                      class="btn btn-link btn-block"
                      @click.prevent="plan.config.from_template = false"
                    >
                      or just start from scratch
                    </button>
                    <button
                      v-if="hasMadeTemplateDecision && showTemplatePickerAgain"
                      class="btn btn-link btn-block"
                      @click.prevent="showTemplatePickerAgain = false"
                    >
                      or cancel and keep working
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>

        <!--

        <div v-if="activitySummary.length">

          <div class="my-5">
            <hr>
          </div>

          <section class="main">
            <header>
              <h3 class="h">
                My Tasks
              </h3>
              <hr>
            </header>
            <section>

              <table class="table table-bordered" style="border: 2px solid #111; border-radius: 4px;">
                <thead>
                  <tr class="bg-dark text-center text-white text-uppercase font-weight-normal small">
                    <th>Lead Source</th>
                    <th>Marketing Task /Channel</th>
                    <th>Timeframe</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="activity in activitySummary">
                    <td class="p-1">{{ activity.source }}</td>
                    <td class="p-1">{{ activity.content && activity.content.name }}</td>
                    <td class="p-1">{{ activity.frequency }}</td>
                  </tr>
                </tbody>
              </table>
            </section>
          </section>
        </div>

        -->

      </div>

      <div
        v-if="preview"
        class="text-center my-3"
      >
        <button
          class="btn btn-primary btn-lg"
          @click.prevent="closePreview()"
        >
          <i class="fa fa-fw fa-close mr-1"></i>
          Close Preview
        </button>
      </div>

    </div>
  </div>
</template>

<style lang="scss" scoped>
  .business-plan-editor {

    section.main {
      &> header {
        .h {
          text-transform: uppercase;
          font-weight: bold;
          font-size: 2.8rem;
          text-align: center;
        }
        @media screen and (max-width: 900px) {
          .h {
            font-size: 2rem;
          }
        }
        hr {
          width: 100px;
          margin: 0 auto;
          border-top-width: 3px;
        }
        margin-bottom: 3rem;
      }

      &> section {
        &> header {
          .h {
            margin-bottom: 0;
          }
          hr {
            margin-top: 8px;
            border-top-color: #111;
          }
          margin-bottom: 4rem;
        }
      }
    }

    .border-top-1 {
      border-top: 1px solid #111;
    }

    .border-bottom-1 {
      border-bottom: 1px solid #111;
    }

    .border-width-2 {
      border-width: 2px;
    }

    .card-deck, .card-group {
      .card-body .card-group {
        margin: -1px;
      }
    }

    .marketing-plan-template-picker {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      width: 100%;
      height: 100%;
      background-color:rgba(0, 0, 0, 0.80);
    }

    .sample-marketing-plan {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      width: 100%;
      height: 100%;
      text-align: center;
      padding-top: 200px;
      span {
        text-align: center;
        display: block;
        transform: rotate(-30deg);
        font-size: 10rem;
        font-weight: bold;
        text-transform: uppercase;
        color: rgba(180, 180, 180, 0.30);
      }
    }

  }
</style>

<script>
import $ from 'jquery'
import numeral from 'numeral'
import MyWhy from '@/components/business-plan-editor/MyWhy'
import LeadSources from '@/components/business-plan-editor/LeadSources'
import LeadSourcePlanning from '@/components/business-plan-editor/LeadSourcePlanning'
import MyActivities from '@/components/business-plan-editor/MyActivities'
import Notes from '@/components/business-plan-editor/Notes'
import Tip from '@/components/Tip'
import NumberBox from '@/components/business-plan-editor/NumberBox'
import LargeInput from '@/components/business-plan-editor/LargeInput'
import LeadSourceBarChart from '@/components/business-plan-editor/LeadSourceBarChart'
import LeadSourcePieChart from '@/components/business-plan-editor/LeadSourcePieChart'
import NotesModal from '@/components/NotesModal'
import { getBusinessPlanLtmStats, saveBusinessPlanConfig, getBusinessPlan, markBusinessPlanNotCopiedInto, copyIntoBusinessPlan, rebuildTasks, optOutOfBusinessPlan, optIntoBusinessPlan } from '@/api'
import urls from '@/api/urls'
import { sum, get, map, debounce, cloneDeep } from 'lodash'
import alertify from 'alertify.js'
import wait from '@/lib/wait'
import StrategyInput from '@/components/business-plan-editor/StrategyInput'
import WistiaLink from '@/components/WistiaLink'
import { ToggleButton } from 'vue-js-toggle-button'
import InlineEditor from '@/components/InlineEditor'
import { MessageBag } from '@/lib/MessageBag'

const colors = [
  'rgba(189, 175, 138, 1.000)',
  'rgba(65, 65, 67, 1.000)',
  'rgba(109, 110, 114, 1.000)',
  'rgba(189, 190, 192, 1.000)',
  'rgba(17, 13, 72, 1.000)',
  'rgba(79, 195, 208, 1.000)',
  'rgba(1, 88, 79, 1.000)',
  'rgba(116, 25, 94, 1.000)',
  'rgba(146, 63, 33, 1.000)'
]

const roundUpToEvenNumber = (number) => {
  let ceil = Math.ceil(number)
  return ceil % 2 ? ceil + 1 : ceil
}

const mightBeLessThanOne = (number) => {
  return number < 1.0 ? 'Less than 1' : roundUpToEvenNumber(number)
}

const pieChartOptions = {
  tooltips: {
    mode: 'index',
    intersect: true,
    callbacks: {
      label (tooltipItem, data) {
        // console.log(tooltipItem, data)
        let prefix = data.labels[tooltipItem.index]
        let value = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index]
        let proportion = Math.round(value / sum(data.datasets[tooltipItem.datasetIndex].data) * 100)
        if (data.datasets[tooltipItem.datasetIndex].label === 'Gross Sales') {
          value = numeral(value).format('$0,0')
        }
        return `${prefix}: ${value} (${proportion}%)`
      }
    }
  },
  legend: {
    display: true,
    position: 'bottom'
  }
}

const barChartOptions = {
  tooltips: {
    mode: 'index',
    intersect: true,
    callbacks: {
      label (tooltipItem, data) {
        // console.log(tooltipItem, data)
        let prefix = data.datasets[tooltipItem.datasetIndex].label
        let value = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index]
        let proportion = Math.round(value / sum(data.datasets[tooltipItem.datasetIndex].data) * 100)
        if (data.datasets[tooltipItem.datasetIndex].label === 'Gross Sales') {
          value = numeral(value).format('$0,0')
        }
        return `${prefix}: ${value} (${proportion}%)`
      }
    }
  },
  legend: {
    display: true,
    position: 'bottom'
  },
  scales: {
    xAxes: [{
      padding: 0,
      ticks: {
        autoSkip: false,
        maxRotation: 0,
        minRotation: 0
      },
      gridLines: {
        display: false
      }
    }],
    yAxes: [{
      display: false,
      padding: 0,
      id: 'sides',
      ticks: {
        beginAtZero: true
      },
      gridLines: {
        display: false
      }
    }, {
      display: false,
      padding: 0,
      id: 'money',
      position: 'right',
      ticks: {
        beginAtZero: true
      },
      gridLines: {
        display: false
      }
    }]
  }
}

export default {
  name: 'BusinessPlanEditor',
  components: {
    InlineEditor,
    Notes,
    Tip,
    MyWhy,
    LeadSources,
    LeadSourcePlanning,
    LeadSourceBarChart,
    LeadSourcePieChart,
    MyActivities,
    NumberBox,
    NotesModal,
    LargeInput,
    StrategyInput,
    ToggleButton,
    WistiaLink
  },
  props: {
    userId: {
      type: String,
      required: true
    },
    preview: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    year: {
      type: [String, Number],
      required: false
    },
    canManageAgents: {
      type: [Boolean, Number],
      default: false
    },
    canActivatePlan: {
      type: [Boolean, Number],
      default: false
    },
    templates: {
      type: Array,
      default () {
        return [
          //
        ]
      }
    },
    leadSources: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      urls,
      saving: false,
      error: false,
      incomplete: 0,
      chartType: null,
      dataset: null,
      loaded: false,
      oops: false,
      approvedLtm: false,
      showTaskRebuild: false,
      rebuildingTaskList: false,
      showTaskRebuildDone: false,
      showTaskRebuildSkipped: false,
      showCompPlanSettings: false,
      showActivationSuccess: false,
      showSaveSuccess: false,
      showNotes: false,
      marketingPlanTemplateChoice: null,
      showGoals: 'annual',
      compPlan: {
        split: {
          agent_generated: null,
          company_generated: null,
          team: null
        },
        cap: {
          company: null,
          team: null
        }
      },
      activityFrequencies: [
        'Daily',
        'Weekly',
        '2x Month',
        'Monthly',
        'Quarterly',
        '2x Year',
        '3x Year',
        'Annually'
      ],
      activityChannels: [
        'Advertising',
        'Hosting',
        'Networking',
        'Prospecting',
        'Publishing',
        'Purchasing',
        'Social Media'
      ],
      leadSourceStrategies: [
        'Activity',
        // 'Prospecting',
        // 'Networking',
        // 'Advertising',
        // 'Hosting',
        // 'Publishing',
        // 'Purchasing'
      ],
      optedOut: null,
      showTemplatePickerAgain: false,
      plan: {
        is_template: false,
        id: null,
        active: null,
        year: null,
        opted_out: null,
        user: {
          name: null
        },
        config: {
          previous_plan: {
            id: null
          },
          x_template_name: null,
          from_template: null,
          sales_volume: null,
          why: {
            benefits: [],
            consequences: [],
            description: null,
            vision: null
          },
          sellers: {
            portion: null,
            avg_sale_price: null,
            avg_commission: null,
            conversion_rate: 0
          },
          is_team_member: false,
          buyers: {
            portion: null,
            avg_sale_price: null,
            avg_commission: null,
            conversion_rate: 0
          },
          leases: {
            portion: null,
            avg_commission: null
          },
          outbounds: {
            transactions: 0,
            avg_sale_price: null
          },
          convos: {
            conversion_rate: 0
          },
          income_goal: null,
          transactions: null,
          gross_commissions: 2.5,
          co_generated_business: 0,
          lead_sources: [],
          prospecting: {
            type: 'prospecting_hour',
            custom: {
              start: null,
              end: null
            }
          },
          split: {
            agent_generated: 100,
            company_generated: 50,
            team: 100
          },
          cap: {
            company: 0,
            team: 0
          }
        }
      },
      meta: {},
      stats: {
        listings: {
          labels: [],
          sales: [],
          counts: []
        },
        rentals: {
          labels: [],
          sales: [],
          counts: []
        }
      },
      previousPlans: [],

      // showCopyPreviousPlan: false,

      copyPreviousPlan: false,
      copyFromPlan: null
    }
  },
  computed: {
    leadSourcesValues: {
      get () {
        return this.leadSources
      },
      set () {
        //
      }
    },
    franchiseSplit () {
      return 6;
    },
    personalSplitForAgentGeneratedBusiness () {
      return get(this.plan, 'config.split.agent_generated', 100)
    },
    personalSplitForCompanyGeneratedBusiness () {
      return get(this.plan, 'config.split.company_generated', 50)
    },
    personalSplitForTeam () {
      return get(this.plan, 'config.split.team', 100)
    },
    companyCap () {
      return this.plan.config.cap.company
    },
    teamCap () {
      return this.plan.config.cap.team
    },
    hasMadeTemplateDecision () {
      if (this.plan.year >= 2021) {
        return get(this, 'plan.config.from_template') !== null
      } else {
        return true // not supported in older versions
      }
    },
    customProspectingHourEnd: {
      get () {
        return get(this, 'plan.config.prospecting.custom.end', '11:00')
      },
      set (value) {
        this.plan.config.prospecting.custom.end = value
      }
    },
    customProspectingHourStart: {
      get () {
        return get(this, 'plan.config.prospecting.custom.start', '10:00')
      },
      set (value) {
        this.plan.config.prospecting.custom.start = value
      }
    },
    leasesAvgCommissionOptions () {
      let options = []
      for (let i = 25; i <= 75; i += 5) {
        options.push({
          text: `${i}%`,
          value: i
        })
      }
      return options
    },
    allowManualSalesVolume () {
      return this.plan.year && this.plan.year >= 2021
    },
    showTopLevelConversationGoals () {
      return this.plan.year && this.plan.year < 2021
    },
    showConversionGoals () {
      return this.plan.year && this.plan.year >= 2021
    },
    showBenefitsAndConsequencesEditors () {
      return this.plan.year && this.plan.year < 2021
    },
    showMyWhyDescriptionAndVision () {
      return this.plan.year && this.plan.year >= 2021
    },
    showProspectingGoals () {
      return this.plan.year >= 2021
    },
    portionsDoNotAddUpTo100 () {
      let sum = parseInt(get(this, 'plan.config.sellers.portion') || 0) + parseInt(get(this, 'plan.config.buyers.portion') || 0) + parseInt(get(this, 'plan.config.leases.portion') || 0)
      return sum !== 100
    },
    totalConversations () {
      return 0
    },
    rentals () {
      return this.getConfig(get(this.stats, 'rentals'))
    },
    listings () {
      return this.getConfig(get(this.stats, 'listings'))
    },
    prospectingGoalType: {
      get() {
        return get(this, 'plan.config.prospecting.type', 'prospecting_hour')
      },
      set(value) {
        this.plan.config.prospecting.type = value
      }
    },
    placeholders () {
      if (!get(this.meta, 'transactions')) {
        return {}
      }

      let placeholders = {
        transactions: numeral(roundUpToEvenNumber(this.meta.transactions * 1.1)).format('0,0'),
        sales_volume: numeral(roundUpToEvenNumber(this.meta.total_sales * 1.1)).format('0,0'),
        sides_close_rate: 33,
        sellers_portion: Math.round(this.meta.sellers.count / Math.max(this.meta.transactions, 1) * 100),
        sellers_avg_sale_price: numeral(Math.max(this.meta.sellers.avg_sale_price, this.meta.avg_selling_price)).format('0,0'),
        sellers_avg_commission: numeral(Math.max(Math.ceil(this.meta.sellers.avg_sale_price * 0.02), this.meta.avg_gci_list)).format('0,0'),
        buyers_portion: Math.round(this.meta.buyers.count / Math.max(this.meta.transactions, 1) * 100),
        buyers_avg_sale_price: numeral(Math.max(this.meta.buyers.avg_sale_price, this.meta.avg_selling_price)).format('0,0'),
        buyers_avg_commission: numeral(Math.max(Math.ceil(this.meta.buyers.avg_sale_price * 0.02), this.meta.avg_gci_sale)).format('0,0'),
        leases_portion: Math.round(this.meta.leases.count / Math.max(this.meta.transactions, 1) * 100),
        leases_avg_sale_price: numeral(this.meta.leases.avg_sale_price).format('0,0'),
        leases_avg_commission: numeral(Math.ceil(this.meta.leases.avg_sale_price * 0.02)).format('0,0'),
        co_generated_business: 0
      }

      placeholders.gross_commissions = roundUpToEvenNumber(placeholders.sales_volume * 0.02)

      return placeholders
    },
    personalIncomeGoal: {
      set (value) {
        if (!this.allowManualSalesVolume) {
          this.plan.config.income_goal = value
        } else {
          // not set, calculated automatically
        }
      },
      get () {
        if (this.allowManualSalesVolume) {
          let commission = this.salesVolume * this.commissionRate
          let personalSplit = this.personalSplitForAgentGeneratedBusiness / 100

          // deduct Franchise fee
          let franchiseCommission = commission * this.franchiseSplit / 100
          commission -= franchiseCommission

          // deduct Team commission
          let teamMemberSplit = this.personalSplitForTeam / 100
          let teamSplit = 1 - teamMemberSplit
          let teamCommission = Math.min(
            this.teamCap > 0 ? this.teamCap : Number.MAX_SAFE_INTEGER,
            commission * teamSplit
          )
          commission -= teamCommission

          // deduct Company commission
          let companySplit = 1 - personalSplit
          let companyCommission = Math.min(
            this.companyCap > 0 ? this.companyCap : Number.MAX_SAFE_INTEGER,
            commission * companySplit
          )
          commission -= companyCommission

          return commission
        } else {
          return this.plan.config.income_goal
        }
      }
    },
    outboundIncomeGoal () {
      let transactions = parseInt(get(this.plan, 'config.outbounds.transactions', 0))
      let price = parseInt(get(this.plan, 'config.outbounds.avg_sale_price', 0))
      return transactions * price * 0.025 * 0.21
    },
    totalIncomeGoal () {
      let incomeGoal = this.personalIncomeGoal
      let coGen = get(this.plan, 'config.co_generated_business', 0)
      let outbounds = this.outboundIncomeGoal
      return numeral(parseInt(incomeGoal) + parseInt(coGen) + parseInt(outbounds)).format('$0,0')
    },
    commissionRate () {
      let gross = get(this.plan, 'config.gross_commissions')
      if (gross < 1) {
        gross *= 100
      }
      return gross / 100
    },
    grossCommissions () {
      return this.personalIncomeGoal / this.commissionRate
    },
    salesVolume: {
      get () {
        if (this.allowManualSalesVolume) {
          return this.plan.config.sales_volume || 0
        } else {
          return Math.round(this.grossCommissions / (1 - (this.franchiseSplit / 100)))
        }
      },
      set (value) {
        if (this.allowManualSalesVolume) {
          this.plan.config.sales_volume = value
        } else {
          // do nothing; we don't store it
        }
      }
    },
    salesVolumeHelp () {
      let split = this.personalSplitForAgentGeneratedBusiness + '%'
      if (this.personalSplitForAgentGeneratedBusiness < 100) {
        split = this.personalSplitForAgentGeneratedBusiness + '/' + (100 - this.personalSplitForAgentGeneratedBusiness)
      }

      let cap = '$0'
      if (this.companyCap > 0) {
        cap = numeral(this.companyCap).format('$0,0')
      }

      return `Assuming a ${split} split and a ${cap} cap`
    },
    transactionsGoal () {
      let value = parseInt(this.totalSellerTransactions) + parseInt(this.totalBuyerTransactions)
      return value < 1 ? '?' : value
    },
    totalSellerTransactions: {
      get () {
        /*
        let income = this.personalIncomeGoal
        let portion = get(this.plan, 'config.sellers.portion')
        let avg = get(this.plan, 'config.sellers.avg_sale_price')
        let com = get(this.plan, 'config.sellers.avg_commission')

        if (income && portion && com) {
          if (portion < 1) {
            portion *= 100
          }
          if (com < 1) {
            com *= 100
          }
          return Math.ceil(income * portion / 100 / (avg * com / 100))
        } else {
          return 0
        }
        */

        let sales = this.salesVolume
        let portion = get(this.plan, 'config.sellers.portion')
        let avg = get(this.plan, 'config.sellers.avg_sale_price')

        if (sales && portion && avg) {
          if (portion < 1) {
            portion *= 100
          }
          return Math.ceil(sales * (portion / 100) / avg)
        } else {
          return 0
        }
      },
      set () {
        //
      }
    },
    totalSellerAppointments: {
      get () {
        let rate = get(this.plan, 'config.sellers.close_rate')

        if (this.totalSellerTransactions && rate) {
          if (rate < 1) {
            rate *= 100
          }
          return Math.ceil(this.totalSellerTransactions / rate * 100)
        } else {
          return 0
        }
      },
      set () {
        //
      }
    },
    totalBuyerTransactions: {
      get () {
        /*
        let income = this.personalIncomeGoal
        let portion = get(this.plan, 'config.buyers.portion')
        let avg = get(this.plan, 'config.buyers.avg_sale_price')
        let com = get(this.plan, 'config.buyers.avg_commission')

        if (income && portion && com) {
          if (portion < 1) {
            portion *= 100
          }
          if (com < 1) {
            com *= 100
          }
          return Math.ceil(income * portion / 100 / (avg * com / 100))
        } else {
          return 0
        }
        */

        let sales = this.salesVolume
        let portion = get(this.plan, 'config.buyers.portion')
        let avg = get(this.plan, 'config.buyers.avg_sale_price')

        if (sales && portion && avg) {
          if (portion < 1) {
            portion *= 100
          }
          return Math.ceil(sales * (portion / 100) / avg)
        } else {
          return 0
        }
      },
      set () {
        //
      }
    },
    totalBuyerConsultations () {
      let rate = get(this.plan, 'config.buyers.close_rate')

      if (this.totalBuyerTransactions && rate) {
        if (rate < 1) {
          rate *= 100
        }
        return Math.ceil(this.totalBuyerTransactions / rate * 100)
      } else {
        return 0
      }
    },
    totalLeaseTransactions: {
      get () {
        let income = this.personalIncomeGoal
        let portion = get(this.plan, 'config.leases.portion')
        let com = get(this.plan, 'config.leases.avg_commission')
        let avgRent = get(this.plan, 'config.leases.avg_rent')

        if (income && portion && com && avgRent) {
          if (portion < 1) {
            portion *= 100
          }
          if (com < 1) {
            com *= 100
          }
          return Math.ceil(income * portion / 100 / (com / 100 * avgRent))
        } else {
          return 0
        }
      },
      set () {
        //
      }
    },
    totalLeaseConsultations () {
      let rate = get(this.plan, 'config.leases.close_rate')

      if (this.totalLeaseTransactions && rate) {
        if (rate < 1) {
          rate *= 100
        }
        return Math.ceil(this.totalLeaseTransactions / rate * 100)
      } else {
        return 0
      }
    },
    quotaConvosAnnual: {
      get () {
        let txns = (this.totalSellerTransactions + this.totalBuyerTransactions)
        // default conversation rate is 40/1
        return txns * (get(this.plan, 'config.convos.conversion_rate') || 40)
      },
      set () {
        // do nothing
      }
    },
    quotaConvosWeekly: {
      get () {
        return Math.ceil(this.quotaConvosAnnual / 42)
      },
      set () {
        // do nothing
      }
    },
    quotaConvosMonthly: {
      get () {
        return Math.ceil(this.quotaConvosAnnual / 12)
      },
      set () {
        // do nothing
      }
    },
    quotaConvosDaily: {
      get () {
        return roundUpToEvenNumber(this.quotaConvosWeekly / 5)
      },
      set () {
        // do nothing
      }
    },
    quotaConvosKnown: {
      get () {
        return this.quotaConvosDaily / 2
      },
      set () {
        // do nothing
      }
    },
    quotaConvosUnknown: {
      get () {
        return this.quotaConvosDaily / 2
      },
      set () {
        // do nothing
      }
    },
    quotaListingApptsAnnual: {
      get () {
        return this.totalSellerTransactions / ((get(this.plan, 'config.sellers.conversion_rate') || 50) / 100)
      },
      set () {
        // do nothing
      }
    },
    quotaListingApptsWeekly: {
      get () {
        return mightBeLessThanOne(this.quotaListingApptsAnnual / 42.0)
      },
      set () {
        // do nothing
      }
    },
    quotaListingApptsMonthly: {
      get () {
        return mightBeLessThanOne(this.quotaListingApptsAnnual / 12.0)
      },
      set () {
        // do nothing
      }
    },
    quotaListingApptsDaily: {
      get () {
        return mightBeLessThanOne(this.quotaListingApptsAnnual / 42.0 / 5.0)
      },
      set () {
        // do nothing
      }
    },
    quotaBuyerApptsAnnual: {
      get () {
        return this.totalBuyerTransactions / ((get(this.plan, 'config.buyers.conversion_rate') || 20) / 100)
      },
      set () {
        // do nothing
      }
    },
    quotaBuyerApptsWeekly: {
      get () {
        return Math.ceil(this.quotaBuyerApptsAnnual / 42.0)
      },
      set () {
        // do nothing
      }
    },
    quotaBuyerApptsMonthly: {
      get () {
        return mightBeLessThanOne(this.quotaBuyerApptsAnnual / 12.0)
      },
      set () {
        // do nothing
      }
    },
    quotaBuyerApptsDaily: {
      get () {
        return mightBeLessThanOne(this.quotaBuyerApptsAnnual / 42.0 / 5.0)
      },
      set () {
        // do nothing
      }
    },
    activitySummary () {
      let summary = []

      for (const l in this.plan.config.lead_sources) {
        let leadSource = this.plan.config.lead_sources[l]
        for (const s in leadSource.strategies) {
          let strategy = leadSource.strategies[s]
          for (const a in strategy.activities) {
            let activity = strategy.activities[a]
            if (activity.content) {
              summary.push({
                content: activity.content,
                type: strategy.name,
                source: this.leadSourceName(leadSource),
                frequency: activity.frequency
              })
            }
          }
        }
      }

      return summary
    }
  },
  watch: {
    plan: {
      handler: debounce(function () {
        if (!this.preview) {
          this.save()
        }
      }, 300),
      deep: true
    },
    'plan.config.is_team_member' (value) {
      if (!value) {
        this.compPlan.split.team = 100
        this.compPlan.cap.team = 0
      }
    },
    personalIncomeGoal () {

    },
    optedOut () {
      this.optedOut ? optOutOfBusinessPlan(this.userId, this.plan.year) : optIntoBusinessPlan(this.userId, this.plan.year)
    },
    showTemplatePickerAgain (show) {
      if (show) {
        this.$nextTick(() => {
          $('html, body').animate({
            scrollTop: $('#my_marketing_plan').offset().top
          })
        })
      }
    }
  },
  mounted () {
    $('body').prepend($(this.$el).find('.fixed-bottom'))

    if (!this.preview) {
      wait({
        onion: true
      })
    }

    getBusinessPlan(this.userId, this.year)
      .then((response) => {
        this.plan = Object.assign({}, response.data.data)

        // console.log(this.allowManualSalesVolume)

        this.compPlan = {
          split: cloneDeep(this.plan.config.split),
          cap: cloneDeep(this.plan.config.cap)
        }
        this.optedOut = get(this.plan, 'opted_out')
        this.previousPlans = response.data.previousPlans
        this.approvedLtm = !!this.plan.approved_ltm_at


        // if (this.plan.copied_from_year === null && this.previousPlans.length > 0) {
        //   this.showCopyPreviousPlan = true
        // }

        this.loaded = true
      })
      .catch((response) => {
        console.error(response)
        this.oops = true
        wait(false)
      })

    getBusinessPlanLtmStats(this.userId, this.year)
      .then((response) => {
        if (!response.data.meta.transactions) {
          this.error = true
        } else {
          this.meta = response.data.meta
          this.stats = response.data.transactions
          this.incomplete = response.data.meta.incomplete
          $(() => {
            this.chartType = 'pie'
            if (this.stats.listings.counts.length) {
              this.dataset = 'listings'
            } else if (this.stats.rentals.counts.length) {
              this.dataset = 'rentals'
            } else {
              this.dataset = 'listings'
            }
          })
        }
      })
      .catch((response) => {
        console.error(response)
        this.error = true
      })

    $(window).on('rebuildTasks.requested', () => {
      this.showTaskRebuild = true
    })
  },
  methods: {
    saveCompPlan () {
      this.plan.config.split = cloneDeep(this.compPlan.split)
      this.plan.config.cap = cloneDeep(this.compPlan.cap)
      this.showCompPlanSettings = false
    },
    cancelSavingCompPlan () {
      this.compPlan.split = cloneDeep(this.plan.config.split)
      this.compPlan.cap = cloneDeep(this.plan.config.cap)
      this.showCompPlanSettings = false
    },
    closePreview () {
      window.close()
    },
    showHelp () {
      $(window).trigger('help.requested')
    },
    setTemplate () {
      let $form = $('#business_plan_template_picker')
      if (!this.marketingPlanTemplateChoice) {
        alertify.alert('Oops! You need to make a template selection before you can continue')
      } else {
        alertify.confirm('Are you sure you want to load a new marketing plan into this business plan? This will wipe out any marketing plan you have already written.', () => {
          $form[0].submit()
        })
      }
    },
    confirmTaskRebuild () {
      this.showTaskRebuild = false
      alertify.confirm('Are you sure you want to rebuild your task list? This cannot be undone.', () => {
        this.rebuildingTaskList = true
        rebuildTasks(this.userId, this.plan.year)
          .then(() => {
            this.rebuildingTaskList = false
            this.showTaskRebuild = false
            this.showTaskRebuildDone = true
          })
          .catch(() => {
            wait.oops()
            this.rebuildingTaskList = false
          })
      }, () => {
        // do nothing
      })
    },
    skipTaskRebuild () {
      this.exit()
    },
    reload () {
      document.location.reload()
    },
    exit () {
      document.location = urls.businessPlan.showTracker(this.userId)
    },
    onStrategySelection (selection, strategy) {
      strategy.frequency = selection.default_frequency
    },
    save () {
      if (this.readonly) {
        return wait.loaded()
      }

      if (this.loaded) {
        wait.saving()
        return saveBusinessPlanConfig(this.userId, this.plan.config, this.plan.year, false)
          .then(() => {
            wait.saved()
          })
          .catch((e) => {
            wait.oops()
          })
      }
    },
    saveAndActivate() {
      if (this.loaded) {
        wait.saving()
        return saveBusinessPlanConfig(this.userId, this.plan.config, this.plan.year, true)
          .then(() => {
            wait.saved()
            this.showActivationSuccess = true
          })
          .catch((e) => {
            wait.oops()
            let message = MessageBag.fromResponse(e).first()
            alertify().alert(`Oops! We can't activate your plan yet. ${message}`)
          })
      }
    },
    saveAndShowTaskRebuild () {
      if (this.loaded) {
        this.saveAndActivate().then(() => {
          this.showTaskRebuild = true
        })
      }
    },
    copyIntoPlan () {
      alertify.confirm(`Are you sure you want to copy your ${this.copyFromPlan} plan and overwrite this one?`, () => {
        copyIntoBusinessPlan(this.userId, this.plan.year, this.copyFromPlan)
          .then(() => {
            this.reload()
          })
      })
    },

    // doNotCopyIntoPlan () {
    //   markBusinessPlanNotCopiedInto(this.userId, this.plan.year)
    //     .then(() => {
    //       this.showCopyPreviousPlan = false
    //     })
    // },

    addBenefit () {
      this.plan.config.why.benefits.push({ content: '' })
    },
    removeBenefit (i) {
      alertify.confirm('Are you sure you want to remove this from the list?', () => {
        this.plan.config.why.benefits.splice(i, 1)
      })
    },
    addConsequence () {
      this.plan.config.why.consequences.push({ content: '' })
    },
    removeConsequence (i) {
      alertify.confirm('Are you sure you want to remove this from the list?', () => {
        this.plan.config.why.consequences.splice(i, 1)
      })
    },
    removeActivity (activities, i) {
      alertify.confirm('Are you sure you want to delete this activity?', () => {
        activities.splice(i, 1)
      })
    },
    addActivity (activities) {
      activities.push({
        content: null,
        frequency: 'Daily'
      })
    },
    addLeadSource () {
      let strategies = map(this.leadSourceStrategies, (strategy) => {
        return {
          name: strategy,
          activities: [
            { content: null, frequency: 'Daily' }
          ]
        }
      })
      this.plan.config.lead_sources.push({ name: '', custom: '', strategies })
    },
    removeLeadSource (i) {
      alertify.confirm('Are you sure you want to remove this from the list?', () => {
        this.plan.config.lead_sources.splice(i, 1)
      })
    },
    leadSourceName (source) {
      if (source.name === 'Custom' || source.name === 'Other') {
        return source.custom
      } else if (source.name === 'Geographic Farm' || source.name === 'Geo-Farming') {
        return source.custom ? `Geo Farm: ${source.custom}` : 'Geo-Farming'
      } else if (source.name === 'Niche' || source.name === 'Niche Marketing') {
        return source.custom ? `Niche: ${source.custom}` : 'Niche Marketing'
      } else {
        return source.name
      }
    },
    getConfig (config) {
      return {
        countsPieChartData: {
          datasets: [{
            data: config.counts,
            backgroundColor: colors,
            label: 'Transactions'
          }],
          labels: config.labels
        },
        salesPieChartData: {
          datasets: [{
            data: config.sales,
            backgroundColor: colors,
            label: 'Gross Sales'
          }],
          labels: config.labels
        },
        barChartData: {
          datasets: [{
            data: config.counts,
            backgroundColor: 'rgba(65, 65, 67, 0.5)',
            borderColor: 'rgba(65, 65, 67, 1.0)',
            label: 'Transactions',
            yAxisID: 'sides'
          }, {
            data: config.sales,
            backgroundColor: 'rgba(189, 175, 138, 0.500)',
            borderColor: 'rgba(189, 175, 138, 1.0)',
            label: 'Gross Sales',
            yAxisID: 'money'
          }],
          labels: config.labels
        },
        pieChartOptions,
        barChartOptions
      }
    }
  }
}
</script>
